import { h } from 'preact';
import { ComponentWithDropdown } from '../../common/ComponentWithDropdown';
import { IEmptyState, INavigateAsProps } from '../sgwt-super-header.types';
import OnBehalfSelector from './OnBehalfSelector';

const Popover = require('react-bootstrap/lib/Popover');
const OverlayTrigger = require('react-bootstrap/lib/OverlayTrigger');

export default class NavigateAs extends ComponentWithDropdown<INavigateAsProps, IEmptyState> {
  private overlay: any;

  constructor(props: INavigateAsProps) {
    super(props);
  }

  private selectUser(user: any) {
    // Hide the popover
    this.overlay && this.overlay.hide();
    this.props.onNavigateAsSelectUser(user);
  }

  render(props: INavigateAsProps): JSX.Element | null {
    // User not connected, so we do not put the "navigate as" feature.
    if (!props.user || !props.user!.mail) {
      return null;
    }
    if (props.navigateAsList && props.navigateAsList.length > 0) {
      const popover =
        <Popover id="on-behalf-popover">
          <OnBehalfSelector
            labels={props.labels}
            list={props.navigateAsList}
            onNavigateAsSelectUser={user => this.selectUser(user)}/>
        </Popover>;
      return (
          <OverlayTrigger
            trigger="click"
            placement="bottom"
            overlay={popover}
            ref={(overlay: any) => { this.overlay = overlay; }}>
            <li id="sgwt-super-header-navigate-as-link"><a style="cursor: pointer" onClick={ () => { this.props.onNavigateAsClick(); } }>{ props.labels.navigateAs } <span class="caret"/></a></li>
          </OverlayTrigger>
      );
    }
    // Feature "navigate as" managed by application, we only emit an event
    if (props.navigateAs) {
      return (
        <li id="sgwt-super-header-navigate-as-link"><a style="cursor: pointer" onClick={ () => { this.props.onNavigateAsClick(); } }>{ props.labels.navigateAs } <span class="caret"/></a></li>
      );
    }
    // Feature "navigate as" not used...
    return null;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-super-header/components/NavigateAs.tsx